import React from 'react';
import CheckBoxFilter from '../components/_MediaCheckBox';

function SearchMediaFilter({ search, filter }) {
	return (
		<div>
			<hr />
			{filter.taxonomyPathFilters && 
				filter.taxonomyPathFilters.Media && 
				filter.taxonomyPathFilters.Media.children.map((t) => (<CheckBoxFilter key={t.key} search={search} node={t} filter='contentType' />))}
		</div>
	);
}

export default SearchMediaFilter;
